import type { Theme } from "@mui/system";
import { TaxSubmissionStatus } from "../dtos/TaxSubmissionStatus";

export const getColorByTaxSubmissionStatus = (
    status: TaxSubmissionStatus,
    theme: Theme,
) => {
    let themeColor: string;
    let vaporColor:
        | "blueSapphire"
        | "islamicGreen"
        | "russianViolet"
        | "maximumPurple"
        | "mediumSlateBlue"
        | "prune"
        | "royalFuchsia"
        | "rustyRed";

    switch (status) {
        case TaxSubmissionStatus.GENERIC_ERROR:
        case TaxSubmissionStatus.NOT_SENT_WITH_ERRORS:
            themeColor = theme.palette.primary.accentRustyRed;
            vaporColor = "rustyRed";
            break;
        case TaxSubmissionStatus.READY_TO_SEND:
            themeColor = theme.palette.primary.accentMediumSlateBlue;
            vaporColor = "mediumSlateBlue";
            break;
        case TaxSubmissionStatus.REJECTED:
            themeColor = theme.palette.primary.accentPrune;
            vaporColor = "prune";
            break;
        case TaxSubmissionStatus.OUTCOME_DOWNLOAD_ERROR:
        case TaxSubmissionStatus.SENT_WITH_WARNINGS:
        case TaxSubmissionStatus.SENT:
            themeColor = theme.palette.primary.accentIslamicGreen;
            vaporColor = "islamicGreen";
            break;
        case TaxSubmissionStatus.PENDING:
        default:
            themeColor = theme.palette.primary.accentBlueSapphire;
            vaporColor = "blueSapphire";
            break;
    }

    return {
        themeColor,
        vaporColor,
    };
};
